import { observer } from 'mobx-react';
import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ClearIcon from '@material-ui/icons/Clear';
import { withStyles } from '@material-ui/core/styles';


const styles = theme => ({
  value: {
    userSelect: 'none',
    cursor: 'default',
  },
});


@withStyles(styles)
@observer
class UploadField extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any,
    multiple: PropTypes.bool,
    fullWidth: PropTypes.bool,
    error: PropTypes.bool,
    helperText: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    variant: PropTypes.string,
  };

  static defaultProps = {
    value: [],
    multiple: false,
    fullWidth: false,
    error: false,
    helperText: '',
    variant: 'outlined',
    onChange: null,
  };

  get files() {
    const { value } = this.props;
    if (value === '') {
      return [];
    }
    if (typeof value === 'string') {
      return [value];
    } else {
      return [...value];
    }
  }

  clear = () => {
    const event = { target: { files: [] }};
    this.props.onChange(event);
  };

  get empty() {
    return this.files.length === 0;
  }

  render() {
    const {
      label, variant, onChange, multiple, fullWidth, error, helperText, classes,
    } = this.props;
    return (
      <TextField
        type="file"
        label={label}
        variant={variant}
        fullWidth={fullWidth}
        error={error}
        helperText={helperText}
        onChange={onChange}
        InputLabelProps={{shrink: !this.empty}}
        InputProps={{
          startAdornment:
            this.empty
              ? null
              : (
                <Typography noWrap style={{width: '100%'}} className={classes.value}>
                  {
                    this.files.map(
                      file => typeof file === 'string' ? file : file.name
                    ).join(', ')
                  }
                </Typography>
              ),
          endAdornment:
            this.empty
              ? null
              : (
                <InputAdornment position="end">
                  <Tooltip title="Clear">
                    <IconButton onClick={this.clear}>
                      <ClearIcon/>
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              )
        }}
        inputProps={{
          multiple,
          style: {
            opacity: 0,
            width: this.files.length === 0 ? null : 0,
          },
        }}
      />
    );
  }
}


export default UploadField;
